export enum StockOfferType {
  StockedProduct = 'StockedProduct',
  PreparingProduct = 'PreparingProduct',
  PlannedProduct = 'PlannedProduct'
}
